import { render, staticRenderFns } from "./UserDeletion.vue?vue&type=template&id=30bb80ee&scoped=true"
import script from "./UserDeletion.vue?vue&type=script&lang=ts"
export * from "./UserDeletion.vue?vue&type=script&lang=ts"
import style0 from "./UserDeletion.vue?vue&type=style&index=0&id=30bb80ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bb80ee",
  null
  
)

export default component.exports